import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import AuthWrapper from 'components/auth/wrapper'
import FormHeader from 'components/auth/formHeader'
import AlertBar from 'components/shared/alertBar'
import {ALERT_TYPES} from 'constants'
import Input from 'components/shared/form/input'
import {parseError} from 'utils'
import Button from 'components/shared/buttons'
import {resetPassword, verifyOTP} from 'services/api/actions'
import {resetPasswordSchema, verifyOTPSchema} from 'utils/validations'
import {LOGIN} from 'router/routes'
import {toast} from 'react-toastify'
import {INPUT_TYPES} from 'constants'

const initialValues = {
  otp: '',
  new_password: '',
  confirm_password: '',
}

const ResetPassword = () => {
  const navigate = useNavigate()

  const [verified, setVerified] = useState(false)
  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState(false)

  const verifyOTPNumber = (values, setStatus) => {
    setLoading(true)
    verifyOTP(values)
      .then((response) => {
        setLoading(false)
        setHasErrors(false)
        setStatus('')
        setToken(response.data.token)
        resetForm()
        setVerified(true)
      })
      .catch((error) => {
        setLoading(false)
        setHasErrors(true)
        setStatus(parseError(error))
        setToken('')
      })
  }

  const onResetPassword = (values, setStatus) => {
    setLoading(true)
    resetPassword(values)
      .then(() => {
        setLoading(false)
        setHasErrors(false)
        setStatus('')
        setToken('')
        toast.success('Password updated successfully')
        navigate(LOGIN)
      })
      .catch((error) => {
        setLoading(false)
        setHasErrors(true)
        setStatus(parseError(error))
      })
  }

  const onSubmit = (values, {setStatus}) => {
    if (verified)
      onResetPassword(
        {new_password: values.new_password, confirm_password: values.confirm_password, token},
        setStatus
      )
    else verifyOTPNumber({otp: values.otp}, setStatus)
  }

  const {handleSubmit, getFieldProps, resetForm, touched, errors, status} = useFormik({
    initialValues,
    validationSchema: verified ? resetPasswordSchema : verifyOTPSchema,
    onSubmit,
  })

  return (
    <AuthWrapper>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        onSubmit={handleSubmit}
      >
        <FormHeader
          title='Reset Password'
          subTitle={verified ? 'Enter new password Details.' : 'Enter OTP, sent to your email.'}
        />
        <AlertBar message={status} type={hasErrors ? ALERT_TYPES.danger : ALERT_TYPES.success} />

        {verified ? (
          <>
            <div className='mb-10 fv-row'>
              <Input
                label='New Password'
                placeholder='New Password'
                type={INPUT_TYPES.password}
                touched={!!touched.new_password}
                error={errors.new_password || ''}
                {...getFieldProps('new_password')}
              />
            </div>

            <div className='fv-row mb-5'>
              <Input
                label='Confirm New Password'
                placeholder='New Password confirmation'
                type={INPUT_TYPES.password}
                touched={!!touched.confirm_password}
                error={errors.confirm_password || ''}
                {...getFieldProps('confirm_password')}
              />
            </div>
          </>
        ) : (
          <div className='mb-10 fv-row'>
            <Input
              label='OTP'
              placeholder='OTP'
              type={INPUT_TYPES.text}
              touched={!!touched.otp}
              error={errors.otp || ''}
              {...getFieldProps('otp')}
            />
          </div>
        )}

        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <Button
            className='fw-bolder me-4'
            loading={loading}
            disabled={loading}
            label='Continue'
          />

          <Button
            className='fw-bolder'
            type='button'
            styleType='secondary'
            label='Cancel'
            disabled={loading}
            onClick={() => navigate(LOGIN)}
          />
        </div>
      </form>
    </AuthWrapper>
  )
}

export default ResetPassword
